<template lang="html">
  <section class="ctn-operation-form take-place">
  	<div class="white-box row title">
  		<router-link :to="{ name: 'SubscriptionsTable' }" class="ctn-icon">
  			<span class="icon-arrow-back"></span>
  		</router-link>
			<div class="label" v-if="subscriptionExist">
				Modifier l'abonnement
			</div>
			<div class="label" v-else>
				Nouvel abonnement
			</div>
  	</div>
		<div class="white-box">
			<edit-main></edit-main>
			<div class="take-place" v-if="subscriptionExist">
        <div class="separator"></div>
				<edit-docs :subscription="subscription" @needToUpdate="checkForSubscription"></edit-docs>
			</div>
			<div class="take-place" v-if="subscriptionExist">
        <div class="separator"></div>
				<edit-actions :subscription="subscription"></edit-actions>
			</div>
		</div>
  </section>
</template>

<script>
import EditMain from './EditForm/Main'
import EditDocs from './EditForm/Docs'
import EditActions from './EditForm/Actions'

export default {
	components: {
		EditMain,
		EditDocs,
		EditActions
	},
	data () {
		return {
			subscriptionExist: false,
			subscription: null
		}
	},
	mounted () {
		this.checkForSubscription()
	},
	methods: {
		checkForSubscription () {
			if (this.$route.name === 'MySubscriptionsEdit') {
				this.$store.dispatch('getSubscription', this.$route.params.id).then((result) => {
					this.subscription = this.$store.getters.subscription(this.$route.params.id)
					this.name = this.subscription.title
					this.subscriptionExist = true
				}).catch((error) => {
					console.log(error)
				})
			}
		}
	},
	watch: {
		$route (to, from) {
			this.checkForSubscription()
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Edit.vue?f6f73722